import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../../../../components/button/CustomButton';
import DashboardCard from '../../../../../../../components/dashboard-card/EndToEndCard.tsx/DashboardCard';
import Earnings from './components/Earnings';

const EarningsChartCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <DashboardCard
      mainStackSpacing={0}
      headlineEndElement={
        <CustomButton variant="secondary" onClick={() => navigate('./end-to-end')}>
          {t('common.projects')}
        </CustomButton>
      }
      renderComponentSx={{
        height: '100%',
      }}
      headline={t('common.earnings')}
      renderComponent={<Earnings />}
      sx={{
        width: { md: '100%', lg: '50%' },
        minHeight: '306px',
      }}
    />
  );
};

export default EarningsChartCard;
